/**
 * Hamburger menus — animated expand/collapse of sub-menus.
 */

function openSubmenu( el ) {
	el.dataset.open = 'true';
	el.style.height = el.scrollHeight + 'px';

	el.addEventListener( 'transitionend', function done( event ) {
		if ( event.target !== el || event.propertyName !== 'height' ) {
			return; // ignore bubbling transitionend from nested submenus
		}
		el.removeEventListener( 'transitionend', done );
		if ( el.dataset.open === 'true' ) {
			el.style.height = 'auto';
		}
	} );
}

function closeSubmenu( el ) {
	el.dataset.open = 'false';
	el.style.height = el.getBoundingClientRect().height + 'px'; // auto → fixed px
	void el.offsetHeight;                                       // force reflow
	el.style.height = '0px';
}

function prepareMenu( menu ) {
	menu.querySelectorAll( '.submenu' ).forEach( ( submenu ) => {
		submenu.hidden = false;
		submenu.style.height = '0px';
		submenu.dataset.open = 'false';
	} );
	// enable CSS transitions only after the initial collapse has painted
	requestAnimationFrame( () => menu.classList.add( 'is-ready' ) );
}

/**
 * Quicklinks "Menu" button ⇄ Main nav.
 * Toggles #main-nav (fade + slide, styled in nav.css) and the button's
 * aria-expanded, which drives the hamburger → X animation and colours.
 */
function initMainNavToggle() {
	const toggle = document.querySelector( '.hamburger[aria-controls="main-nav"]' );
	const nav = document.getElementById( 'main-nav' );
	if ( ! toggle || ! nav ) {
		return;
	}

	const setOpen = ( open ) => {
		toggle.setAttribute( 'aria-expanded', String( open ) );
		nav.classList.toggle( 'is-open', open );
		document.documentElement.classList.toggle( 'is-menu-open', open );
	};

	toggle.addEventListener( 'click', ( event ) => {
		event.preventDefault();
		setOpen( toggle.getAttribute( 'aria-expanded' ) !== 'true' );
	} );

	document.addEventListener( 'keydown', ( event ) => {
		if ( event.key === 'Escape' && toggle.getAttribute( 'aria-expanded' ) === 'true' ) {
			setOpen( false );
			toggle.focus();
		}
	} );
}

function initHamburgerSubmenus() {
	document.querySelectorAll( '.hamburger-menu' ).forEach( prepareMenu );

	document.addEventListener( 'click', ( event ) => {
		const toggle = event.target.closest( '.hamburger-menu .submenu-toggle' );
		if ( ! toggle ) {
			return;
		}

		const submenu = document.getElementById( toggle.getAttribute( 'aria-controls' ) );
		if ( ! submenu ) {
			return;
		}

		const isOpen = toggle.getAttribute( 'aria-expanded' ) === 'true';
		toggle.setAttribute( 'aria-expanded', String( ! isOpen ) );
		( isOpen ? closeSubmenu : openSubmenu )( submenu );
	} );
}

initHamburgerSubmenus();
initMainNavToggle();
